import { forwardRef } from '@wordpress/element';
import { Field, Select } from '../primitives';
import { Item } from './item';
import type { SelectControlProps } from './types';

/**
 * A complete select field with integrated label and description.
 */
export const SelectControl = forwardRef<
	HTMLButtonElement,
	SelectControlProps
>( function UnforwardedSelectControl(
	{
		className,
		children,
		items,
		label,
		description,
		details,
		hideLabelFromVision,
		placeholder,
		popupWidth = 'content',
		size = 'default',
		triggerContent,
		...restProps
	},
	ref
) {
	return (
		<Field.Root className={ className }>
			<Field.Label hideFromVision={ hideLabelFromVision }>
				{ label }
			</Field.Label>
			<Select.Root items={ items } { ...restProps }>
				<Select.Trigger
					ref={ ref }
					placeholder={ placeholder }
					size={ size }
				>
					{ triggerContent }
				</Select.Trigger>
				<Select.Popup width={ popupWidth }>
					{ children !== undefined
						? children
						: items?.map( ( item ) => (
								<Item
									key={ item.value ?? 'null' }
									value={ item }
									label={ item.label }
									disabled={ item.disabled }
								>
									<Select.ItemLabel>
										{ item.label }
									</Select.ItemLabel>
									{ item.description ? (
										<Select.ItemDescription>
											{ item.description }
										</Select.ItemDescription>
									) : null }
								</Item>
							) ) }
				</Select.Popup>
			</Select.Root>
			{ description && (
				<Field.Description>{ description }</Field.Description>
			) }
			{ details && <Field.Details>{ details }</Field.Details> }
		</Field.Root>
	);
} );
